import { useEffect } from 'react';
import { useApiClient } from '@/contexts/ApiContext';
import { useAuthStore } from '@/stores/authStore';
import { getDeviceFingerprint } from '@/utils/deviceFingerprint';

let sent = false;

export function useDeviceSignalReport(): void {
  const apiClient = useApiClient();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || sent) return;
    sent = true;
    const run = () => {
      void (async () => {
        const fp = await getDeviceFingerprint();
        if (!fp) return;
        try {
          await apiClient.api.deviceSignalControllerReport({ fpHash: fp.fpHash, fpVersion: 2, components: fp.components });
        } catch {
          sent = false;
        }
      })();
    };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 5000 });
    else setTimeout(run, 2000);
  }, [isAuthenticated, apiClient]);
}
